export default "/profile/images/viber.svg?38ac00f515ab835735852f4fc70bed70";